import React, { useState, useEffect, useContext, useRef } from "react";
import { DataGrid, gridClasses } from "@mui/x-data-grid";

import { Link, useNavigate } from "react-router-dom";
import { useForm, Controller } from "react-hook-form";
import FormControlLabel from "@mui/material/FormControlLabel";
import dayjs from "dayjs";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";


import { useQuery, useManualQuery, useMutation, ClientContext } from "graphql-hooks";

import {
  Container,
  Card,
  CardContent,
  Grid,
  Typography,
  Divider,
  TextField,
  Radio,
  Checkbox,
  Tooltip,
  Button,
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
  DialogContentText,
  FormHelperText,
  makeStyles,
} from "@material-ui/core";
import Box from "@mui/material/Box";
import styled from "styled-components";

import Header from "./Header.js";
import AlertDialog from "../../components/AlertDialog.js";

import { CREATE_TEAM_MUTATION, GET_TEAM_DATA_BY_NAME } from "../../graphQL/team_qry";
import { REFRESH_TOKEN_MUTATION, STAFF_MODULE_ACCESS_QUERY } from "../../graphQL/user_qry";

import { project_url } from "../../constants/Data";

var findAnd = require("find-and");

const useStyles = makeStyles(theme => ({

  textFieldInput: {  
       
    height: "50px",
    maxHeight: "100px",
    width: "400px",
    
  },

  root: {
    marginRight: "8rem",
    textAlign: "center",
    padding: theme.spacing(2),
    paddingLeft: 0,
    paddingRight: 0,
    width: "1400px",
    paddingTop: "7rem",
    //  minWidth: "500px",
  },
  container: {
    padding: theme.spacing(4),
    marginTop: "1rem",
    marginBottom: "5rem",
    overflow: "hidden",
    clear: "both",
    borderRadius: "8px",
    minHeight: "870px",
    backgroundColor: "#ffffff",
  },
  outlinedButtonStyle: {
    borderRadius: 8,
    width: "110px",
    padding: 0,
    height: "48px",
    textTransform: "none",
  },
  errorStyle: {
    marginTop: 0,
    fontSize: 14, //16,
    fontFamily: "Arial",
    paddingLeft: 5,
  },
  buttonStyle: {
    borderRadius: 4,
    width: "100px",
    padding: 0,
    color: "#fff",
    height: "34px",
    backgroundColor: "#0D47A1",
    textTransform: "none",
    "&:hover": {
      backgroundColor: "#1E88E5",
    },
  },
  dataGridStyle: {
    width: "100%",
    "& .super-app-theme--header": {
      backgroundColor: "#99D4FF",//"#0D47A1",
      color: "#0D47A1",
      fontSize: 18,
      fontWeight: 700,
    },
    "& .MuiDataGrid-cell": {
      fontSize: 16,
      fontWeight: 400,
    },
    "& .MuiDataGrid-columnHeader .MuiDataGrid-columnSeparator": {
      display: "none",
    },
    "& .MuiDataGrid-row.Mui-selected": {
      backgroundColor: "none !important",
    },
    "& .MuiDataGrid-row:hover": {
      backgroundColor: "none !important",
    },
    "& .MuiDataGrid-cell:focus-within": {
      outline: " none !important",
    },
    [`& .${gridClasses.row}.even`]: {
      backgroundColor: "#FFFFFF",
    },
    [`& .${gridClasses.row}.odd`]: {
      backgroundColor: "#E3F2FD",
    },
    [`& .${gridClasses.row}.even:hover`]: {
      backgroundColor: "#FFFFFF",
    },
    [`& .${gridClasses.row}.odd:hover`]: {
      backgroundColor: "#E3F2FD",
    },
    [`& .${gridClasses.row}.even.Mui-selected`]: {
      backgroundColor: "#FFFFFF !important",
    },
    [`& .${gridClasses.row}.odd.Mui-selected`]: {
      backgroundColor: "#E3F2FD !important",
    },
  },

  textFieldStyle: {
    marginBottom: 5,
    "& .MuiInputLabel-outlined": {
      fontSize: 16,
    },
    "& .MuiOutlinedInput-root": {
      borderRadius: 10,
      fontSize: 16,
    },
  },
  datePickerStyle: {
    marginBottom: 5,
    "& .MuiInputLabel-outlined": {
      fontSize: 16,
    },
    "& .MuiOutlinedInput-root": {
      borderRadius: 10,
      fontSize: 16,
    },
  },
}));

function TeamAdd() {
  const [loadContent, setLoadContent] = useState(false);
  const client = useContext(ClientContext);
  const navigate = useNavigate();
  const [pathname] = useState(window.location.pathname);
  const [refreshToken] = useMutation(REFRESH_TOKEN_MUTATION, {
    onError: err => {
      console.log(err);
    },
  });
  useEffect(() => {
    if (localStorage.getItem("refreshToken")) {
      onRefreshToken();
    } else window.location.href = `${project_url}/signin/?next=${pathname}`;
  }, []);
  const onRefreshToken = async () => {
    const { data: refreshData, error: refreshError } = await refreshToken({
      variables: { refreshToken: localStorage.getItem("refreshToken") },
    });
    if (refreshError) {
      if (
        refreshError.graphQLErrors[0].message ===
        "You do not have permission to perform this action"
      )
        window.location.href = `${project_url}/signin/?next=${pathname}`;
      if (refreshError.graphQLErrors[0].message === "Signature has expired")
        window.location.href = `${project_url}/signin/?next=${pathname}`;
    }
    if (refreshData && refreshData.refreshToken) {
      localStorage.setItem("token", refreshData.refreshToken.token);
      localStorage.setItem("refreshToken", refreshData.refreshToken.refreshToken);
      client.setHeader("Authorization", `JWT ${refreshData.refreshToken.token}`);
      setLoadContent(true);
    }
  };

  const classes = useStyles();
  const [errorMsg, setErrorMsg] = useState({
    teamName: "",    
  });
  
  const [alertMsg, setAlertMsg] = useState([]);

  const [addAccess, setAddAccess] = useState(true);
  

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const clientName  = localStorage.getItem("clientName");
  
  const tenantName = localStorage.getItem("tenantName");
  const tenantId = localStorage.getItem("tenantId");

  let tenantUserId = 0;
  if(localStorage.getItem("tenantUserId"))
    tenantUserId = localStorage.getItem("tenantUserId");

  let isTenantAdmin = false;  
  if(localStorage.getItem("isTenantAdmin"))
    isTenantAdmin = JSON.parse(localStorage.getItem("isTenantAdmin"));

  let clientId = 0;
  if (localStorage.getItem("clientId")) 
    clientId = localStorage.getItem("clientId");

  const [checkStaffModuleAccess] = useManualQuery(STAFF_MODULE_ACCESS_QUERY, {
    fetchPolicy: "network-only",
  });

  const [createTeam] = useMutation(CREATE_TEAM_MUTATION, {
    //refetchQueries: [{ query: FIND_FORM_FOR_CLIENT_QUERY }],
    awaitRefetchQueries: true,
  });

  const [getTeamData] = useManualQuery(GET_TEAM_DATA_BY_NAME, {
    fetchPolicy: "network-only",
  });

  const formatter = new Intl.DateTimeFormat("en-us", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  });

  const dayFormat = day => {
    const dayDate = new Date(day);
    const dayFormat = formatter.formatToParts(dayDate);

    const newFormat =
      dayFormat.find(a => a.type == "month").value +
      "/" +
      dayFormat.find(a => a.type == "day").value +
      "/" +
      dayFormat.find(a => a.type == "year").value;
    return newFormat;
  };

  const checkAccess = async () => {
    //check if staff has access to module
    
    const {
            loading: accessDataLoading,
            error: accessDataError,
            data: accessData,
          } = await checkStaffModuleAccess({
            variables: {
              tenantUserId: parseInt(tenantUserId),  
              clientId: parseInt(clientId), 
              moduleName: "Teams",
              modulepageName: "List"     
            },
          });

    if (!accessDataLoading && accessData && accessData.staffModuleAccess) {      
      console.log('accessData.staffModuleAccess',accessData.staffModuleAccess)
      let commonActions = accessData.staffModuleAccess.commonActions.split('|');
      
      if(commonActions.find(a => a == "Add"))
        setAddAccess(true);
      else  
        setAddAccess(false);    
      
    }

    if (  accessDataError &&
          accessDataError.graphQLErrors &&
          accessDataError.graphQLErrors[0].message === "Signature has expired"
       ) {
            navigate(`${project_url}/signin`);
          }
  }

  
   useEffect(() => {
    window.scrollTo(0, 0);
    (() => checkAccess())();
  }, []);

  
  const onSubmit = async formData => {
    //check if entered name exist in client or not
    const {
      loading: teamLoading,
      error: teamError,
      data: teamData,
    } = await getTeamData(
      {
        variables: { 
          name: formData.teamName, 
          clientId: parseInt(clientId) , 
          teamId: null},
      });

    if (!teamLoading && teamData && teamData.getTeamDataByName){
      setErrorMsg(
        { teamName: "This name has been exist in client, please enter another name." }
      );
    }
    else {
      setErrorMsg({});
      const { data, error } = await createTeam({
        variables: {
          name: formData.teamName,
          clientId: parseInt(clientId),
          desc: formData.desc 
           },
          });
      if (error) {
        console.log("Error", error, data);
        setAlertMsg({
          title: "Error",
          msg: "Unfortunately an error occurred.",
             });
        } 
      else if (data && data.createTeam) {
        console.log("Success", data);
        setAlertMsg({
          title: "Success",
          msg: "New Team has been successfully added.",
        });
        navigate(`${project_url}/teams`)
      }
    }
  };
  
  if (loadContent)
    if (addAccess)
    return (
      <div className={classes.root}>
        <Header breadcrumbs={[{ label: "Add Team", link: null }]} />
        <div className={classes.container}>
          <Box mt={2} mb={2} textAlign="center">
            <Typography variant="body1" style={{ marginBottom: 10 }}>
              Add Team
            </Typography>
          </Box>
          <Divider />
          <form onSubmit={handleSubmit(onSubmit)}>
            <Grid container spacing={3} style={{ marginTop: 30 }}>
              <Grid item xs={4}>
                <TextField
                  className={classes.textFieldStyle}
                  autoFocus
                  fullWidth
                  label="Team Name"
                  margin="normal"
                  name="teamName"
                  type="teamName"
                  variant="outlined"
                  id="teamName"
                  {...register("teamName", { required: true })}
                />

                 {errors.teamName && errors.teamName.type === "required" && (
                  <FormHelperText className={classes.errorStyle} error>
                    Team Name cannot be blank.
                  </FormHelperText>
                )}

                {errorMsg.teamName && (
                  <FormHelperText className={classes.errorStyle} error>
                    {errorMsg.teamName}
                  </FormHelperText>
                )} 

                <TextField
                  className={classes.textFieldStyle}
                  multiline
                  rows={6}
                  label="Description"
                  margin="normal"
                  name="desc"
                  
                  variant="outlined"
                  id="desc"
                  {...register("desc")}
                  inputProps={{
                    maxLength: 254,
                  }}
                  InputProps={{
                      classes: {
                         input: classes.textFieldInput
                      },
                    }}
                />               
              </Grid>
                            
              
            </Grid>
            
            <Box pt={4} pb={2}>
              <Button
                variant="contained"
                color="primary"
                className={classes.buttonStyle}
                style={{ marginRight: 2 }}
                type="submit"
              >
                Save
              </Button>

              <Button
                variant="text"
                color="primary"
                className={classes.outlinedButtonStyle}
                onClick={() => navigate(`${project_url}/teams`)}
              >
                Cancel
              </Button>
            </Box>
          </form>
          {alertMsg.msg && (
            <AlertDialog
              title={alertMsg.title}
              contentMsg={alertMsg.msg}
              closeDialog={() => {
                setAlertMsg([]);
                alertMsg.title === "Success" && navigate(`${project_url}/teams`);
              }}
            />
          )}
        </div>
      </div>
    );
     else
      return (
        <div className={classes.root}>          
          <div className={classes.container}>
            <AlertDialog
                title="No Permission"
                contentMsg='You do not have permission to access this page.
                            Click the "Done" button and navigate the system through the designated menu options on the sidebar menu.' 
                closeDialog={() => {
                  navigate(`${project_url}/tenant/dashboard`);
                }}
              />
            
          </div>
        </div>
      );
  else return;
}

export default TeamAdd;
